import { IPromise, IHttpService } from "angular";
import HttpService from "../http.service";
import { StudentPlan } from "./package.model";

/* @ngInject */
export default class StudentPlanService{

    constructor(
        private httpService: HttpService,
        private $http: IHttpService
    ) {}

    public getUserStudentStatus(): IPromise<StudentPlan> {
        return this.httpService.getResultFromCache('studentStatus', 'hafifmuzik/mobile/student/status');
    }
    
}


// WEBPACK FOOTER //
// ./src/app/common/services/package/student.service.ts